import { ArrowRight, Check, Clock3, MapPinned, ShieldCheck, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import { LaunchForm } from '../components/LaunchForm';
import { PhonePreview } from '../components/PhonePreview';
import { CTASection, SectionIntro, ServiceCard, TrustCard } from '../components/Sections';
import { services, trustPoints } from '../data';

export function Home() {
  return (
    <>
      <section className="hero">
        <div className="hero__mesh" />
        <div className="container hero__grid">
          <div className="hero__copy">
            <span className="launch-pill"><i /> Pakistan-wide mobility platform</span>
            <h1>Your city.<br /><em>Your ride.</em></h1>
            <p className="hero__lede">
              A locally built platform for city and intercity rides plus within-city courier requests—designed
              to make each step feel clear, connected and confidently yours.
            </p>
            <div className="button-row">
              <Link className="button button--primary" to="/services/rides">Explore rides <ArrowRight size={18} /></Link>
              <Link className="button button--secondary" to="/captains">Drive with Sawwari</Link>
            </div>
            <div className="hero__assurance">
              <span><ShieldCheck /> Reviewed captain profiles</span>
              <span><MapPinned /> Built for local journeys</span>
            </div>
          </div>
          <PhonePreview />
        </div>
        <div className="container hero-form-wrap">
          <LaunchForm compact />
        </div>
      </section>

      <section className="section section--services">
        <div className="container">
          <SectionIntro
            eyebrow="One platform, more ways to move"
            title="Designed around real city needs."
            text="Start with the service you need today, then move through a focused experience built for that journey."
          />
          <div className="service-grid">
            {services.map((service) => <ServiceCard service={service} key={service.title} />)}
          </div>
        </div>
      </section>

      <section className="section section--ink">
        <div className="container split-story">
          <div className="split-story__visual" aria-hidden="true">
            <div className="city-card">
              <span className="city-card__sun" />
              <div className="city-card__hills" />
              <div className="city-card__road" />
              <div className="city-card__car">S</div>
              <div className="city-card__caption">
                <small>Built across</small>
                <strong>Pakistan</strong>
              </div>
            </div>
          </div>
          <div className="split-story__copy">
            <span className="eyebrow">Local by design</span>
            <h2>National platform. Local authorization. Responsible growth.</h2>
            <p>
              Sawwari is designed for travel across Pakistan, with each city, route and category activated
              only when its operating, transport and safety requirements are ready.
            </p>
            <ul className="feature-list">
              <li><span><Check /></span><div><strong>Pakistan-wide model</strong><p>City and intercity journeys are part of the core service.</p></div></li>
              <li><span><Clock3 /></span><div><strong>Clear request flow</strong><p>Designed to show the right choice at the right moment.</p></div></li>
              <li><span><Sparkles /></span><div><strong>Locally controlled rollout</strong><p>Availability follows city, category and regulatory readiness.</p></div></li>
            </ul>
            <Link className="text-link text-link--light" to="/services">See the service experience <ArrowRight size={17} /></Link>
          </div>
        </div>
      </section>

      <section className="section section--trust">
        <div className="container">
          <SectionIntro
            eyebrow="Trust is part of the journey"
            title="Thoughtful controls, visible support."
            text="Trust is built through reviewed information, clear choices and a support trail that does not disappear after the journey ends."
            align="center"
          />
          <div className="trust-grid">
            {trustPoints.map((item) => <TrustCard item={item} key={item.title} />)}
          </div>
          <div className="trust-banner">
            <div className="trust-banner__icon"><ShieldCheck /></div>
            <div>
              <span className="eyebrow">Safety centre</span>
              <h3>Know what Sawwari is designed to do before you travel.</h3>
            </div>
            <Link className="button button--secondary" to="/safety">Explore safety</Link>
          </div>
        </div>
      </section>

      <CTASection
        title="A new local journey starts here."
        text="Explore the passenger experience or preview the path to becoming a Sawwari Captain."
        primary={{ label: 'Explore rides', to: '/services/rides' }}
        secondary={{ label: 'Become a Captain', to: '/captains' }}
      />
    </>
  );
}
